import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from 'styled-components';
import { getColor } from '../../V2/Elements/Icons/helpers';
const Icon = React.forwardRef(function Icon({ size = 24, alt, color, className, onClick }, ref) {
    const theme = useTheme();
    const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
    return (_jsx("svg", { ref: ref, onClick: onClick, width: size, height: size, viewBox: '0 0 48 48', className: className, fill: fillColor, children: _jsx("path", { d: 'M40 36c2.21 0 3.98-1.79 3.98-4l.02-22c0-2.21-1.79-4-4-4h-32c-2.21 0-4 1.79-4 4v22c0 2.21 1.79 4 4 4h-8c0 2.21 1.79 4 4 4h40c2.21 0 4-1.79 4-4h-8zm-32-26h32v22h-32v-22zm16 28c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' }) }));
});
export default React.memo(Icon);
